<template>
  <div class="p1_bgpage p1_spage">
    <!--login-->
    <div class="p1_slogin">
      <!--logined-->
      <div class="p1_bglogined p1_slogined flex-row" v-if="logined">
        <!---s-tx-phone-->
        <div class="p1_textphone">{{ phone }}</div>
        <!---s-bt-logout-->
        <div class="p1_buttonlogout"><img class="p1_dilogout" @click="logout"
                                          src="../../assets/p1/images/imglogout.png" referrerpolicy="no-referrer"/>
        </div>
      </div>
      <!---s-bt-notlogin-->
      <div class="p1_buttonnotlogin" v-else><img class="p1_dinotlogin" @click="showLogin"
                                                 src="../../assets/p1/images/imgnotlogin.png"
                                                 referrerpolicy="no-referrer"/></div>
    </div>
    <!---s-bt-audio-->
    <div class="p1_buttonaudio">
      <!-- <my-audio></my-audio> -->
    </div>
    <!---s-s-SLOGAN-->
    <div class="p1_sliceSLOGAN"><img class="p1_diSLOGAN" src="../../assets/p1/images/imgSLOGAN.png"
                                     referrerpolicy="no-referrer"/></div>
    <!--dialogs-->
    <div class="p1_sdialogs" v-if="false"></div>
    <!---s-s-SLOGAN-小日期-->
    <div class="p1_sliceSLOGANxiaorq"><img class="p1_diSLOGANxiaorq" src="../../assets/p1/images/imgSLOGAN-xiaorq.png"
                                           referrerpolicy="no-referrer"/></div>
    <!--bar-->
    <bar :value="1"></bar>
    <exchange ref="exchange"></exchange>
    <login-bind ref="loginBind" @login="checkLogin" @bind="checkLogin"></login-bind>

    <show-err ref="showErr"></show-err>
  </div>
</template>

<style lang="css" scoped>
@import url('../../assets/p1/css/s1.css');
</style>

<script>
// import MyAudio from '../../components/audio/index.vue';
import Bar from '../../components/bar/index.vue';
import LoginBind from '../../components/loginbind/index.vue';
import {clearToken, getMobile} from '../../api/common';
import info from '../../api/states/info';
import userInfo from '../../api/states/userinfo';
import ShowErr from '@/components/showerr/index.vue';
import Exchange from "@/components/exchange";
//   require('@/assets/p1/css/s1.css');
export default {
  components: {
    Exchange,
    // MyAudio,
    Bar,
    LoginBind,
    ShowErr
  },
  data() {
    return {
      phone: '',
      logined: false,
      errObj: null,
      loginBind: null,
      exchange: null,
    }
  },
  mounted() {
    info.getTime()
    
    document.getElementsByClassName("p1_buttonaudio")[0].appendChild(this.$myAudio.$el);

    this.errObj = this.$refs.showErr
    this.loginBind = this.$refs.loginBind
    this.exchange = this.$refs.exchange

    this.checkLogin()
  },

  methods: {
    async checkLogin() {
      let hasSendLink = false
      let query = this.$route.query
      if (query.exchangeToken && query.cardId && query.userId) {
        hasSendLink = true
      }

      try {
        let loginRet = await this.loginBind.check(hasSendLink)
        if (loginRet || userInfo.isLogin) {

          this.logined = true
          this.phone = getMobile()
          await info.getInfo()

          if (loginRet && hasSendLink) {
            this.exchange.showBeSend()
          }
        }
      } catch(err) {
        console.log(err)
      }

      // if (!userInfo.isLogin) {
      //   await getUserInfo().then(res => {
      //     console.log(res)
      //     if (res.code === 0) {
      //       this.logined = true

      //       setUserInfo(res)
      //       this.phone = getMobile()
      //     } else if (res.code === 2) {
      //       if (hasSendLink) {
      //         this.loginBind.showLogin()
      //       }
      //     } else {
      //       this.errObj.showErr(res.message)
      //     }
      //   }).catch(err => {
      //     console.log(err)
      //   })
      // } else {
      //   this.logined = true
      //   this.phone = getMobile()
      // }

      // if (userInfo.isLogin && hasSendLink) {
      //   if (!userInfo.isBind) {
      //     this.loginBind.showBind()
      //   } else {
      //     this.exchange.showBeSend()
      //   }
      // }
    },
    showLogin() {
      this.loginBind.showLogin()
    },
    logout() {
      // del token
      this.logined = false
      this.phone = ""
      info.hasInfo = false
      userInfo.isLogin = false
      userInfo.isBind = false
      clearToken()
    },
  }
};
</script>
<style scoped>
.p1_bgpage {
  background-size: 100% auto;
  /*height: auto;*/
}

.p1_spage {
  height: 100vh;
  min-height: 13.34rem;
}


</style>